import Constants from '../../constants';
import './index_mWeb.css';
import MatchMakingLoader from '../../component/match_making_loader';
import MatchMakingPlayerFound from '../../component/match_making_player_found/index';
import AvatarAnimation from '../../component/avatar_animation';
import { RouteWrapper } from '../../component';
import ScreenBackgroundWrapper from '../../component/screen_background_wrapper';
interface Props {
  onCancelHandler?: any;
  onPressTryAgain?: any;
  matchFound?: boolean;
  opponentUser?: any;
  myUserName?: any;
  myAvatarId?: any;
  avatars?: any;
  entryFee?: any;
}

const MatchMakingMWeb = ({
  onCancelHandler,
  onPressTryAgain,
  matchFound = false,
  opponentUser = {},
  myAvatarId = '',
  avatars = [],
  entryFee
}: Props) => {
  const { username: opponentUserName = '', avatarId: opponentAvatarId = 0 } = opponentUser;
  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <div className={'matchMaking__container__mWeb'}>
          <div className={'matchMaking__avatarMainContainer__mWeb'}>
            <div className={'matchMaking__avatarContainer__mWeb'}>
              <div className="matchMaking__avatarWrapper__mWeb">
                <img
                  className={'matchMaking__avatarFrame__mWeb '}
                  src={Constants.Images.MatchMakingAvatarFrame}
                />
                <img className={'matchMaking__avatarImg__mWeb '} src={avatars[myAvatarId]} />
              </div>
              <span className={'matchMaking__avatarName__mWeb '}>{'You'}</span>
            </div>
            <div className={'matchMaking__vsContainer__mWeb '}>
              <img className={'matchMaking__vsImg__mWeb '} src={Constants.Images.MatchMakingVs} />
            </div>
            <div className={'matchMaking__avatarContainer__mWeb '}>
              <div className="matchMaking__avatarWrapper__mWeb">
                <img
                  className={'matchMaking__avatarFrame__mWeb '}
                  src={Constants.Images.MatchMakingAvatarFrame}
                />
                {!matchFound ? (
                  <AvatarAnimation />
                ) : (
                  <img
                    className={'matchMaking__avatarImg__mWeb '}
                    src={avatars[opponentAvatarId]}
                  />
                )}
              </div>
              <span className={'matchMaking__avatarName__mWeb '}>{`${
                matchFound ? opponentUserName : '---'
              }`}</span>
            </div>
          </div>
          <div className="matchMaking__entryFee__wrapper__mWeb">
            <div className="matchMaking__entryFee__title__txt__mWeb">Entry Fee</div>
            <div className="matchMaking__entryFee__amount__wrapper__mWeb">
              <img src={Constants.Images.coin} width={10} />
              <p>{entryFee}</p>
            </div>
          </div>
          <div className="matchMaking__playerSearchContainer__mWeb ">
            {matchFound ? (
              <MatchMakingPlayerFound />
            ) : (
              <MatchMakingLoader onCancel={onCancelHandler} onPressTryAgain={onPressTryAgain} />
            )}
          </div>
        </div>
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};
export default MatchMakingMWeb;
